import { isSEPACountry } from 'ibantools';

import { PaymentFormData } from '@/components/payments/types/payment';
import { isYapealIban } from '@/utils/formats';

export default () => {
  function isSicCurrency(ccy: string) {
    return ['', 'CHF'].includes(ccy);
  }
  function isSepaCurrency(ccy: string) {
    return ccy === 'EUR';
  }
  function isSwiftCurrency(ccy: string) {
    return !isSicCurrency(ccy) && !isSepaCurrency(ccy);
  }

  function isY2YPayment(paymentForm: PaymentFormData) {
    return isYapealIban(paymentForm.beneficiary.iban);
  }

  function isIncorePayment(paymentForm: PaymentFormData) {
    return isSepaPayment(paymentForm) || isSwiftPayment(paymentForm) || !isSicCurrency(paymentForm.currency);
  }

  function isSicPayment(paymentForm: PaymentFormData) {
    return (
      paymentForm.beneficiary.iban === '' ||
      (/^(CH|LI)/.test(paymentForm.beneficiary.iban) && isSicCurrency(paymentForm.currency))
    );
  }

  function isSepaPayment(paymentForm: PaymentFormData) {
    return (
      !isSicPayment(paymentForm) &&
      isSEPACountry(paymentForm.beneficiary.iban.substring(0, 2)) &&
      isSepaCurrency(paymentForm.currency)
    );
  }

  function isSwiftPayment(paymentForm: PaymentFormData) {
    return !isSicPayment(paymentForm) && !isSepaPayment(paymentForm);
  }

  return {
    isSicCurrency,
    isSepaCurrency,
    isSwiftCurrency,
    isIncorePayment,
    isY2YPayment,
    isSicPayment,
    isSepaPayment,
    isSwiftPayment
  };
};
